/** Tracks which inbox conversation is open so alerts can be scoped. */

/** @type {string | null} */
let selectedConversationId = null;

/** @param {string | null} id */
export function setInboxSelectedConversationId(id) {
  selectedConversationId = id && String(id).trim() ? String(id).trim() : null;
}

/** @returns {string | null} */
export function getInboxSelectedConversationId() {
  return selectedConversationId;
}
